module.exports = [{"name":"formType","attribute":"kr-popin","casting":"popin"},{"name":"form.popin.button","attribute":"kr-popin-button","casting":"boolean"}]